import Repository from './repository'
import Service from './service'

export type WorkerRequest =
  | {
      type: 'repository'
      requestId: string
      collection: string
      method: string
      query: any
    }
  | {
      type: 'service'
      requestId: string
      name: string
      method: string
      query: any
    }

export type WorkerResponse =
  | { type: 'response'; requestId: string; result: any }
  | { type: 'response'; requestId: string; error: Error; className: string }
  | { type: 'event'; data: any }

class DataWorker {
  private repository: Repository
  private service: Service

  constructor(private context: Worker) {
    this.context.onmessage = this.handleMessage.bind(this)
    this.repository = new Repository()
    this.service = new Service(this.repository)

    this.service.event.onEvent.subscribe((data) => {
      this.postMessage({ type: 'event', data })
    })
  }

  private handleMessage(event): void {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access -- FIXME: Fix this ESLint violation!
    const data: WorkerRequest = event.data

    const handler = () => {
      switch (data.type) {
        case 'repository':
          return this.repository.invoke(data.collection, data.method, data.query)
        case 'service':
          return this.service.invoke(data.name, data.method, data.query)
      }
    }

    handler()
      .then((result) => {
        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment -- FIXME: Fix this ESLint violation!
        this.postMessage({ type: 'response', requestId: data.requestId, result })
      })
      .catch((error: Error) => {
        const className = error.constructor.name
        error = new Error(error.message)
        this.postMessage({
          type: 'response',
          requestId: data.requestId,
          error,
          className,
        })
      })
  }

  private postMessage(message: WorkerResponse) {
    this.context.postMessage(message)
  }
}

// eslint-disable-next-line @typescript-eslint/no-unsafe-argument -- FIXME: Fix this ESLint violation!
new DataWorker(self as any)
